import { render, staticRenderFns } from "./projectTraining.vue?vue&type=template&id=1c8b94a2&"
import script from "./projectTraining.vue?vue&type=script&lang=js&"
export * from "./projectTraining.vue?vue&type=script&lang=js&"
import style0 from "./projectTraining.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports